function getEntranceCost(state, props) {
  const entranceCost = state.entranceCount === props.targetEntranceCount ? 0 : 1e6;
  return entranceCost;
}
export {
  getEntranceCost
};
//# sourceMappingURL=index203.js.map
